export default __webpack_public_path__ + "static/media/george.a217520d.png";